import { useState } from "react";
import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Pagination from "components/ui/pagination/Pagination";

export default function InventoryControlDataTable({ data }) {
  const { t } = useTranslation();

  /* --------------------------------------------- Start Pagination  -----------------------------------------------*/
  const recordsPerPage = 10;
  const [currentPageActive, setCurrentPageActive] = useState(1);
  const prePage = (currentPage, setCurrentPage) => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = (currentPage, setCurrentPage, npage) => {
    if (currentPage < npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const calculateRecords = (data, currentPage, recordsPerPage) => {
    const firstIndex = (currentPage - 1) * recordsPerPage;
    const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
    return data?.slice(firstIndex, lastIndex);
  };

  // Calculate records for activeDiscounts
  const inventoryControlData = calculateRecords(
    data,
    currentPageActive,
    recordsPerPage
  );
  /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return (
    <>
      <>
        <Table>
          <Thead>
            <Tr>
              <Th>#</Th>
              <Th>{t("pages.reports.reports_tables.name")}</Th>
              <Th>{t("pages.reports.reports_tables.sku")}</Th>
              <Th>{t("pages.reports.reports_tables.barcode")}</Th>
              <Th>{t("pages.reports.reports_tables.storage_unit")}</Th>
              <Th>{t("pages.reports.reports_tables.branch")}</Th>
              <Th>{t("pages.reports.reports_tables.opening_quantity")}</Th>
              <Th>{t("pages.reports.reports_tables.opening_cost")}</Th>
              <Th>{t("pages.reports.reports_tables.purchasing_quantity")}</Th>
              <Th>{t("pages.reports.reports_tables.purchasing_cost")}</Th>
              <Th>
                {t("pages.reports.reports_tables.transfer_receiving_quantity")}
              </Th>
              <Th>
                {t("pages.reports.reports_tables.transfer_receiving_cost")}
              </Th>
              <Th>{t("pages.reports.reports_tables.production_quantity")}</Th>
              <Th>{t("pages.reports.reports_tables.production_cost")}</Th>
              <Th>
                {t("pages.reports.reports_tables.return_from_order_quantity")}
              </Th>
              <Th>
                {t("pages.reports.reports_tables.return_from_order_cost")}
              </Th>
              <Th>{t("pages.reports.reports_tables.total_in_quantity")}</Th>
              <Th>{t("pages.reports.reports_tables.total_in_cost")}</Th>
              <Th>
                {t("pages.reports.reports_tables.return_to_supplier_quantity")}
              </Th>
              <Th>
                {t("pages.reports.reports_tables.return_to_supplier_cost")}
              </Th>
              <Th>
                {t("pages.reports.reports_tables.transfer_sending_quantity")}
              </Th>
              <Th>{t("pages.reports.reports_tables.transfer_sending_cost")}</Th>
              <Th>
                {t(
                  "pages.reports.reports_tables.consumption_from_production_quantity"
                )}
              </Th>
              <Th>
                {t(
                  "pages.reports.reports_tables.consumption_from_production_cost"
                )}
              </Th>
              <Th>
                {t(
                  "pages.reports.reports_tables.consumption_from_order_quantity"
                )}
              </Th>
              <Th>
                {t("pages.reports.reports_tables.consumption_from_order_cost")}
              </Th>
              <Th>
                {t("pages.reports.reports_tables.waste_from_order_quantity")}
              </Th>
              <Th>{t("pages.reports.reports_tables.waste_from_order_cost")}</Th>
              <Th>{t("pages.reports.reports_tables.adjustment_quantity")}</Th>
              <Th>{t("pages.reports.reports_tables.adjustment_cost")}</Th>
              <Th>{t("pages.reports.reports_tables.total_out_quantity")}</Th>
              <Th>{t("pages.reports.reports_tables.total_out_cost")}</Th>
              <Th>{t("pages.reports.reports_tables.count_variance_cost")}</Th>
              <Th>{t("pages.reports.reports_tables.closing_quantity")}</Th>
              <Th>{t("pages.reports.reports_tables.closing_cost")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {inventoryControlData?.map((item, index) => (
              <Tr key={item?.ProductId}>
                <Td>{index + 1}</Td>
                <Td>{item?.ProductName}</Td>
                <Td>{item?.Ref}</Td>
                <Td>{item?.Barcode}</Td>
                <Td>{item?.StorageUnit}</Td>
                <Td>{item?.Branch}</Td>
                <Td>{item?.OpeningQuantity}</Td>
                <Td>{item?.OpeningCost}</Td>
                <Td>{item?.PurchasingQuantity}</Td>
                <Td>{item?.PurchasingCost}</Td>
                <Td>{item?.TransferRecQuantity}</Td>
                <Td>{item?.TransferRecCost}</Td>
                <Td>{item?.ProductionQuantity}</Td>
                <Td>{item?.ProductionCost}</Td>
                <Td>{item?.ReturnFromOrderQuantity}</Td>
                <Td>{item?.ReturnFromOrderCost}</Td>
                <Td>{item?.TotalInQuantity}</Td>
                <Td>{item?.TotalInCost}</Td>
                <Td>{item?.ReturnToSupplierQuantity}</Td>
                <Td>{item?.ReturnToSupplierCost}</Td>
                <Td>{item?.TransferSendingQuantity}</Td>
                <Td>{item?.TransferSendingCost}</Td>
                <Td>{item?.ConsumptionFromProductionQuantity}</Td>
                <Td>{item?.ConsumptionFromProductionCost}</Td>
                <Td>{item?.ConsumptionFromOrderQuantity}</Td>
                <Td>{item?.ConsumptionFromOrderCost}</Td>
                <Td>{item?.WasteFromOrderQuantity}</Td>
                <Td>{item?.WasteFromOrderCost}</Td>
                <Td>{item?.AdjQuantity}</Td>
                <Td>{item?.AdjCost}</Td>
                <Td>{item?.TotalOutQuantity}</Td>
                <Td>{item?.TotalOutCost}</Td>
                <Td>{item?.CountVarianceCost}</Td>
                <Td>{item?.ClosingQuantity}</Td>
                <Td>{item?.ClosingCost}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        <Pagination
          currentPage={currentPageActive}
          setCurrentPage={setCurrentPageActive}
          npage={Math.ceil(data?.length / recordsPerPage)}
          prePage={() => prePage(currentPageActive, setCurrentPageActive)}
          nextPage={() =>
            nextPage(
              currentPageActive,
              setCurrentPageActive,
              Math.ceil(data?.length / recordsPerPage)
            )
          }
        />
      </>
    </>
  );
}
